module.exports = {
  '4.0': '1rem', //must be string - if 4.0 or 4 overrides tailwind default ring-4
};
